import type { ButtonProps as ChakraButtonProps } from "@chakra-ui/react";
import {
  AbsoluteCenter,
  Button as ChakraButton,
  Span,
  Spinner,
} from "@chakra-ui/react";
import * as React from "react";

interface ButtonLoadingProps {
  loading?: boolean;
  loadingText?: React.ReactNode;
  opaque?: boolean;
}

export interface ButtonProps extends ChakraButtonProps, ButtonLoadingProps {}

export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  function Button(props, ref) {
    const {
      loading,
      disabled,
      loadingText,
      children,
      opaque = true,
      ...rest
    } = props;
    return (
      <ChakraButton
        disabled={loading || disabled}
        ref={ref}
        bg={opaque ? "#346864" : "white"}
        color={opaque ? "white" : "#346864"}
        _hover={{
          bg: opaque ? "#346864" : "white",
          transform: "scale(1.05)",
          boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
        }}
        _active={{
          transform: "scale(1)",
        }}
        transition="all 0.2s ease-in-out"
        borderRadius={"30px"}
        fontSize={"13px"}
        fontFamily={"Sora-Regular"}
        fontWeight={500}
        borderColor={"#346864"}
        h="44px"
        _disabled={{ bg: "#D0D5DD", color: "#667085" }}
        {...rest}
      >
        {loading && !loadingText ? (
          <>
            <AbsoluteCenter display="inline-flex">
              <Spinner size="inherit" color="inherit" />
            </AbsoluteCenter>
            <Span opacity={0}>{children}</Span>
          </>
        ) : loading && loadingText ? (
          <>
            <Spinner size="inherit" color="inherit" />
            {loadingText}
          </>
        ) : (
          children
        )}
      </ChakraButton>
    );
  }
);
